import React from "react";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import toast from "react-hot-toast";

const ReferralSection = () => {
  const referralCode = "KKISAN2026";

  const copyToClipboard = () => {
    navigator.clipboard.writeText(referralCode);
    toast.success("Referral code copied");
  };

  return (
    <div>
      <div className="mb-5 border-b border-gray-200 pb-4">
        <h1 className="text-lg font-semibold text-gray-900">Referral</h1>
        <p className="mt-1 text-sm text-gray-500">
          Share your code with friends and family.
        </p>
      </div>

      <div className="mb-5 rounded-lg border border-gray-200 p-4">
        <label className="mb-2 block text-sm font-medium text-gray-700">
          Your Referral Code
        </label>
        <div className="flex flex-col gap-3 sm:flex-row">
          <div className="flex min-h-[44px] flex-1 items-center rounded-md border border-dashed border-gray-300 bg-gray-50 px-3 text-base font-semibold tracking-wider text-gray-900">
            {referralCode}
          </div>
          <button
            onClick={copyToClipboard}
            className="inline-flex items-center justify-center gap-2 rounded-md border border-gray-300 px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-50"
          >
            <ContentCopyOutlinedIcon style={{ fontSize: 17 }} />
            Copy
          </button>
          <button className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-600 px-4 py-2 text-sm font-semibold text-white hover:bg-primary-700">
            <ShareOutlinedIcon style={{ fontSize: 17 }} />
            Share
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-3 md:grid-cols-3">
        {[
          ["1", "Share Code", "Send your referral code."],
          ["2", "They Order", "Friend uses it on first order."],
          ["3", "You Earn", "Rewards are added to wallet."],
        ].map(([step, title, text]) => (
          <div key={step} className="rounded-lg border border-gray-200 p-4">
            <div className="mb-2 flex h-7 w-7 items-center justify-center rounded-full bg-gray-100 text-sm font-semibold text-gray-700">
              {step}
            </div>
            <h2 className="text-sm font-semibold text-gray-900">{title}</h2>
            <p className="mt-1 text-sm text-gray-500">{text}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReferralSection;
